import { createFileRoute } from '@tanstack/react-router';
import { RecurrenceForm } from '@/pages/forecast/recurrences/form/recurrence-form';
import { PROTECTED, FORECAST } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${FORECAST}`;

export const Route = createFileRoute(
  '/protected/_layout/forecast/_layout/recurrences/new'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: NewRecurrenceModal,
});

function NewRecurrenceModal() {
  return <RecurrenceForm returnUrl={RETURN_URL} />;
}
